// VOY-461 — MatchScorePill. The "94% match" / "draft" / "re-ranking" pill on
// each component card (design class .mscore). Per the design the score pill is
// a soft GREEN (mint) tint with a sparkle glyph; purple for the itinerary
// draft; muted for "re-ranking"/"no match" transient states.

import { cn } from '@/lib/utils'

const SparkIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8" />
  </svg>
)

export type MatchScorePillVariant = 'mint' | 'purple' | 'muted'

export interface MatchScorePillProps {
  /** Score in [0,1]; rendered as "{n}% match". Ignored when `label` is set. */
  score?: number | null
  /** Explicit label ("draft", "re-ranking") instead of a percentage. */
  label?: string
  variant?: MatchScorePillVariant
  className?: string
}

export function MatchScorePill({ score, label, variant = 'mint', className }: MatchScorePillProps) {
  const text =
    label != null
      ? label
      : typeof score === 'number'
        ? `${Math.round(score * 100)}% match`
        : null
  if (text == null) return null
  return (
    <span
      className={cn('vmt-mscore', `vmt-mscore--${variant}`, className)}
      aria-label={label ? label : `Match score ${Math.round((score ?? 0) * 100)} percent`}
    >
      <SparkIcon />
      <span>{text}</span>
    </span>
  )
}
